export type Environment = 'dev' | 'qa' | 'prod';
export type LogLevel = 'debug' | 'info' | 'error';

interface EnvironmentConfig {
  API_VERSION: string;
  API_URL: string;
  PORT: number;
  ENV: Environment;
  LOG_LEVEL: LogLevel;
  ENABLE_MOCK: boolean;
  S3_ENDPOINT: string;
}

class EnvironmentService {
  private static instance: EnvironmentService;
  private config: EnvironmentConfig;

  private constructor() {
    this.config = {
      API_VERSION: process.env.REACT_APP_API_VERSION || 'v1',
      API_URL: `${process.env.REACT_APP_API_URL || 'http://localhost:6061'}/api/${process.env.REACT_APP_API_VERSION}`,
      PORT: Number(process.env.REACT_APP_PORT) || 7777,
      ENV: (process.env.REACT_APP_ENV as Environment) || 'dev',
      LOG_LEVEL: (process.env.REACT_APP_LOG_LEVEL as LogLevel) || 'info',
      ENABLE_MOCK: process.env.REACT_APP_ENABLE_MOCK === 'true',
      S3_ENDPOINT: process.env.REACT_APP_S3_ENDPOINT || '',
    };
  }

  public static getInstance(): EnvironmentService {
    if (!EnvironmentService.instance) {
      EnvironmentService.instance = new EnvironmentService();
    }
    return EnvironmentService.instance;
  }

  public getConfig(): EnvironmentConfig {
    return this.config;
  }

  public get apiUrl(): string {
    return this.config.API_URL;
  }

  public get port(): number {
    return this.config.PORT;
  }

  public get environment(): Environment {
    return this.config.ENV;
  }

  public get logLevel(): LogLevel {
    return this.config.LOG_LEVEL;
  }

  public get enableMock(): boolean {
    return this.config.ENABLE_MOCK;
  }

  public get s3Endpoint(): string {
    return this.config.S3_ENDPOINT;
  }

  public isDevelopment(): boolean {
    return this.config.ENV === 'dev';
  }

  public isQA(): boolean {
    return this.config.ENV === 'qa';
  }

  public isProduction(): boolean {
    return this.config.ENV === 'prod';
  }

  public shouldLog(level: LogLevel): boolean {
    const levels: LogLevel[] = ['debug', 'info', 'error'];
    return levels.indexOf(level) >= levels.indexOf(this.config.LOG_LEVEL);
  }
}

export const env = EnvironmentService.getInstance();
export default env; 